import { render } from "./agentlist.vue?vue&type=template&id=9edbd7cc"
import script from "./agentlist.vue?vue&type=script&lang=js"
export * from "./agentlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__